/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authFullApp.defs.js'
export * as $defs from './authFullApp.defs.js'
